import $ from "jquery";
import PageOverlayTipsManager from "./PageOverlayTipsManager";

const OverlayTips = {
    DIRECTION_TOP_LEFT: 5,
    DIRECTION_TOP_RIGHT: 6,
    DIRECTION_BOTTOM_LEFT: 9,
    DIRECTION_BOTTOM_RIGHT: 10,

    _ANCHOR_LEFT: 1,
    _ANCHOR_RIGHT: 2,
    _ANCHOR_TOP: 4,
    _ANCHOR_BOTTOM: 8,

    _idSequence: 0,
    _initialized: false,

    /**
     * Initializes overlay tips system. Runs only one time.
     * @private
     */
    init: function()
    {
        if (!this._initialized)
        {
            // Reposition on window resize
            $(window).resizeThrottle(this._repositionOutsideTips, 100);
            this._initialized = true;
        }
    },

    _repositionOutsideTips: function()
    {
        PageOverlayTipsManager.getInstance().repositionOutsideTips();
    }
};

export default OverlayTips;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/OverlayTips.js